import { EDIT_NEWS_LOADING, EDIT_NEWS_SUCCESS, EDIT_NEWS_ERROR } from "../../../constant/actionTypes";

const editNewsReducer = (state = {}, action) => {
    switch (action.type) {
        case EDIT_NEWS_LOADING: {
            let obj = {
                loading: true
            };
            return obj;
        }
        case EDIT_NEWS_SUCCESS: {
            let obj = {
                loading: false,
                data: action.response.data,
            };
            return obj;
        }
        case EDIT_NEWS_ERROR: {
            let obj = {
                loading: false,
                status: action.response
            };
            return obj;
        }
        default:
            return state;
    }
}

export default editNewsReducer;